import { Button } from "@/components/ui/button";
import { CardSkeleton } from "@/components/ui/card";
import { NavButton } from "@/components/ui/navigation";
import { toast } from "@/components/ui/toast";
import { TextSkeleton } from "@/features/projects/components/text-skeleton";
import { Square2StackIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";

/* Prop Types */
interface ReportInDepthSkeletonProps {
  uploadLength: number;
  isError?: boolean;
}

/*
 * ReportInDepthSkeleton component
 * Skeleton component used for report-in-depth page
 */
export const ReportInDepthSkeleton = ({ uploadLength, isError }: ReportInDepthSkeletonProps) => {
  /* Side effects */
  useEffect(() => {
    // this is mainly used for the study-review page due to it not having a loading modal
    if (isError) {
      toast({ title: "An Error has occured", type: "error" });
    }
  }, [isError]);

  /* Render */
  return (
    <>
      {/* Asset name */}
      <div className="flex flex-row items-center">
        <NavButton />
        <TextSkeleton variant="h2" className="ml-2" />
      </div>

      <div className="grow flex flex-row gap-4 max-h-full overflow-hidden">
        <div className="flex flex-col gap-4 overflow-y-auto min-w-[10vw]">
          {/* AssetThumbnails */}
          {Array.from({ length: uploadLength }).map((_, i) => (
            <CardSkeleton key={i} size="small" loadBody={false} />
          ))}
        </div>

        {/* Asset View */}
        <div className="grow flex flex-row bg-base-300 rounded-lg overflow-hidden max-h-full relative skeleton">
          <div className="absolute right-4 top-4 z-20">
            <Button>
              <Square2StackIcon className="size-3.5 inline-block" />
            </Button>
          </div>
        </div>

        {/* Metrics */}
        <div className="flex flex-col min-w-[370px] max-w-[20vw] p-4 pt-0 min-h-full rounded-lg">
          <div className="flex items-center justify-between pb-2">
            <TextSkeleton variant="h2" />
            <div className="flex items-center gap-2">
              {/* <Progress value={scores.score} className="w-14" /> */}
              <TextSkeleton variant="h2" className="ml-2" />
            </div>
          </div>
          {/* <p className="opacity-70 pb-4">Asset's overall performance across attention KPIs:</p> */}
          <TextSkeleton variant="p" className="w-full mb-2" />
          <TextSkeleton variant="p" className="w-full mb-4" />
          <div className="flex flex-col overflow-auto h-full">
            <div className="flex rounded-t-lg bg-base-200 px-4 py-3 items-center justify-between">
              <TextSkeleton variant="p" />
            </div>
            <div className="flex flex-col">
              <TextSkeleton variant="p" className="w-full my-2" />
              <TextSkeleton variant="p" className="w-full mb-2" />
              <TextSkeleton variant="p" className="w-full mb-2" />
              <TextSkeleton variant="p" className="w-full mb-2" />
              <TextSkeleton variant="p" className="w-full mb-2" />
            </div>
          </div>
        </div>
        {/* <div className="flex flex-col min-w-96 max-w-[25vw] p-4 pt-0 min-h-full rounded-lg">
          <h3 className="font-semibold pb-2">Areas of interest (AOI)</h3>
          <p className="opacity-70">We automatically detected areas of interest (AOIs) within the asset. You can edit AOIs here:</p>
          <div className="flex flex-col overflow-auto h-full pt-4">
            <div className="grid grid-cols-[76px_4fr_1fr] rounded-t-lg bg-base-200 p-3 items-center justify-between">
              <p className="text-sm opacity-60 pl-3">Type</p>
              <p className="text-sm opacity-60 pl-3">Label</p>
            </div>
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="grid grid-cols-[76px_4fr_1fr] p-3 items-center justify-between">
                <div className="size-4 skeleton ml-3"></div>
                <TextSkeleton variant="p" className="ml-3" />
                <div className="justify-self-end size-4 skeleton ml-3"></div>
              </div>
            ))}
            <ButtonSkeleton />
          </div>
        </div> */}
      </div>
    </>
  );
};
